import { createContext, useContext, useMemo } from 'react';
import { gate } from 'hub-http/gates';
const defaultValue = {
  auth: undefined,
  tracker: undefined
};
export const XrayPanelContext = /*#__PURE__*/createContext(defaultValue);
const useScopes = () => {
  const {
    auth
  } = useContext(XrayPanelContext);
  if (!auth) {
    return [];
  }
  return auth.user.scopes;
};
export const useSelectHasScope = scopeToCheck => {
  const scopes = useScopes();
  return useMemo(() => scopes.includes(scopeToCheck), [scopes, scopeToCheck]);
};
const useGates = () => {
  const {
    auth
  } = useContext(XrayPanelContext);
  if (!auth) {
    return [];
  }
  return auth.gates;
};
export const useIsUngatedForReadabilityMetrics = () => {
  const gates = useGates();
  return useMemo(() => gates.includes('CI:Xray:ReadabilityMetrics'), [gates]);
};
export const useIsUngatedForAiSearch = () => {
  const gates = useGates();
  return useMemo(() => gates.includes(gate('AISearchExperiment')), [gates]);
};